<template>
  <div class="stall-wrapper">
    <div class="stall-list">
      <textarea
        v-model.trim="stallName"
        maxlength="6"
        placeholder="请填写档口类型（限6字）"
        @keyup="stallInput"
        @paste="stallInput"
      ></textarea>
    </div>
    <div class="add-btn">
      <div class="btn" @click="save">保存</div>
    </div>
  </div>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import { API } from '@/api'
export default {
  components: {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const { stallId, stallName } = to.query
      vm.stallName = stallName || ''
      vm.stallId = stallId || ''
      vm.type = to.query.type || 1 // //1添加、2修改、3删除
      // eslint-disable-next-line eqeqeq
      const title = vm.type == 1 ? '添加档口类型' : '编辑档口类型'
      navBar.setTitle({
        text: title
      })
      document.title = title
    })
  },
  data() {
    return {
      stallList: [],
      stallName: '',
      stallId: '',
      type: 1
    }
  },
  methods: {
    stallInput(e) {
      if (this.stallName.length > 6) {
        this.$toast({
          message: '字数限制6字以内',
          position: 'top'
        })
      }
    },
    async save() {
      if (this.stallName.length > 6) {
        return this.$toast({
          message: '字数限制6字以内',
          position: 'top'
        })
      }
      try {
        const params = {
          key: 'stall',
          type: this.type,
          name: this.stallName
        }
        // eslint-disable-next-line eqeqeq
        if (this.type == 2) {
          params.id = this.stallId
        }
        await API.account.configOperate(params)
        this.$router.back()
      } catch (error) {
        this.$catch(error)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.stall-wrapper {
  height: 100vh;
  padding-top: 8px;
  box-sizing: border-box;
  overflow: hidden;

  background-color: #f5f5f5;

  @include flex-column;
  .stall-list {
    flex: auto;
    height: 0;

    textarea {
      display: block;

      width: 100%;
      height: 98px;
      padding: 12px 16px;
      background-color: #fff;

      border: 0;

      outline: none;

      box-sizing: border-box;

      font-size: 14px;
      line-height: 20px;
      color: #333;

      resize: none;
    }
  }
}
.add-btn {
  width: 100vw;
  background-color: #fff;
  @include iphonex-padding-bottom(6px);
  @include flex-row-center;
  .btn {
    width: 6.5rem /* 325/50 */;
    height: 0.88rem /* 44/50 */;
    border-radius: 0.8rem /* 40/50 */;
    background-color: #15bb5c;
    @include flex-row-center;
    @include text(0.32rem, #fff);
  }
}
</style>
